import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "hk-section" }
const _hoisted_2 = { class: "hk-wrap" }
const _hoisted_3 = { class: "d-flex flex-wrap justify-center ga-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_app_bar = _resolveComponent("main-app-bar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_main_app_bar),
      _createVNode(_component_v_main, {
        class: "hk-app-bg",
        style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.baseImg + ')' })
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_v_row, { justify: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "8",
                    lg: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, { class: "hk-card pa-8 pa-md-12 text-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, {
                            icon: "mdi-hammer-wrench",
                            size: "64",
                            color: "primary",
                            class: "mb-4"
                          }),
                          _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "hk-heading hk-heading--accent mb-4" }, "Hamarosan", -1)),
                          _cache[5] || (_cache[5] = _createElementVNode("p", { class: "hk-lead mb-8" }, " Ez az oldal még fejlesztés alatt áll. Addig is nézd meg galériánkat, vagy vedd fel velünk a kapcsolatot! ", -1)),
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_v_btn, {
                              color: "primary",
                              variant: "flat",
                              "prepend-icon": "mdi-image-multiple",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('gallery')))
                            }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode(" Galéria ")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_v_btn, {
                              color: "secondary",
                              variant: "outlined",
                              "prepend-icon": "mdi-home",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/')))
                            }, {
                              default: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createTextVNode(" Főoldal ")
                              ])),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}